import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Group, Title } from '@mantine/core'
import { AvatarManager } from '@/features/users/components/User/UserProfileDataEntry'

export const TopBarFormSection = () => {
  const { t } = useTranslation()

  return (
    <>
      <Box mb={'md'}>
        <Group>
          <div className={'flex grow'}>
            <Title mb={'md'} order={4}>
              {t('profile')}
            </Title>
          </div>
        </Group>

        <Box mb={'md'}>
          <AvatarManager />
        </Box>
      </Box>
    </>
  )
}
